import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import "animate.css/animate.compat.css"

// QMI Design System
import './styles/design-tokens.css';
import './styles/bootstrap-overrides.css';
import './styles/utilities.css';
import './styles/landing.css';
import './styles/quote-flow.css';
import './styles/marketplace.css';
import './styles/admin.css';
import './App.css';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from './components/Home';
// Marketplace moved to admin area - commented out public routes
// import { Marketplace } from './components/Marketplace/Marketplace';
// import { LeadDetail } from './components/Marketplace/LeadDetail';

import { Amplify } from "aws-amplify"
import { Authenticator } from '@aws-amplify/ui-react';

import '@aws-amplify/ui-react/styles.css';
import { Login } from './components/Login';

function App() {

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_POOL_ID,
        userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
        loginWith: {
          email: true,
        },
        signUpVerificationMethod: "code",
        userAttributes: {
          email: {
            required: true,
          },
        },
        allowGuestAccess: true,
        passwordFormat: {
          minLength: 8,
          requireLowercase: true,
          requireUppercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
        },
      },
    },
  });


  return (
        <div >
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            {/* Marketplace routes moved to admin area - accessible only when logged in */}
            {/* <Route path="/marketplace" element={<Marketplace />}></Route> */}
            {/* <Route path="/marketplace/lead/:id" element={<LeadDetail />}></Route> */}
            <Route path="/dashboard" element={
                       <Authenticator hideSignUp >
                       {({ signOut, user }) => (
                        <Login user={user} signOut={signOut} />
                       )}
                     </Authenticator>

              }></Route>
        </Routes>
      </BrowserRouter>
      </div>

  );
}

export default App;
